
import routeReplaceSelf from '@/utils/routeReplaceSelf';
//TODO 后续ap相关废弃
const storeAfterSale = {
    path: "storeAfterSale",
    name: "storeAfterSale",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'afterSales',
        icon: 'HSIconfont hs-icon-a-firmwareinfo',
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeApUpgradeHistory',
            name: 'storeApUpgradeHistory',
            component: routeReplaceSelf(() => import('@/views/storeApUpgradeHistory')),
            meta: { code: 'afterSales:storeApUpgrade' },
            children: [
                {
                    path: 'storeApUpgradeAdd',
                    name: 'storeApUpgradeAdd',
                    hidden: true,
                    component: () => import('@/views/storeApUpgradeHistory/components/Add'),
                    meta: {
                        code: 'afterSales_storeApUpgrade_create',
                        activeMenu: 'storeApUpgradeHistory',
                    },
                },
            ]
        }
    ]
};
export default storeAfterSale;
